var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from 'react';
import { styled, keyframes } from '@creditas-ui/system';

var LoadingIcon = function LoadingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    stroke: "#DBE1DD"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Loading_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.648 2.092a10 10 0 0110.594 6.09l-.913.377a9.012 9.012 0 00-9.548-5.488l-.133-.98z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.648 2.092a10 10 0 0110.594 6.09l-.913.377a9.012 9.012 0 00-9.548-5.488l-.133-.98z",
    stroke: "#1F2D27",
    strokeWidth: 2,
    mask: "url(#Loading_svg__a)"
  }));
};

var rotate = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var Spinner = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-itens: center;\n  justify-content: center;\n  animation: ", " 1s linear infinite;\n"])), rotate);

var Loading = function Loading() {
  return /*#__PURE__*/React.createElement(Spinner, {
    "data-testid": "loading"
  }, /*#__PURE__*/React.createElement(LoadingIcon, null));
};

export { Loading };